import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forWho = ['Emprendedores que quieren flujo de caja digital sin sacrificar su privacidad.', 'Profesionales que desean autoridad en su nicho pero odian grabarse a sí mismos.', 'Dueños de negocios compartiendo consejos de salud, finanzas o motorización.', 'Personas tímidas con grandes ideas que quieren impactar el mercado hispano de EE.UU.'];
  const notForWho = ['Personas que buscan "dinero mágico" sin configurar el sistema inicial.', 'Creadores que prefieren el estilo de vida de influencer tradicional y exposición total.', 'Quienes no están dispuestos a invertir al menos una hora a la semana en supervisar su IA.'];
  return <Section data-id="element-11">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-12">
        {/* For Who */}
        <motion.div className="glass-card p-8 md:p-10 rounded-3xl border-green-500/30 relative overflow-hidden" initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-13">
          <div className="absolute top-0 left-0 w-full h-2 bg-green-500/50" data-id="element-14" />
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-green-500/10 rounded-full blur-3xl -z-10" data-id="element-15" />

          <h2 className="text-3xl font-bold mb-8 text-white flex items-center gap-3" data-id="element-16">
            <CheckCircle2 className="text-green-400" size={36} data-id="element-17" />
            Esto Es Para Ti Si...
          </h2>

          <ul className="space-y-6" data-id="element-18">
            {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-19">
                <div className="mt-1 bg-green-500/20 p-1 rounded-full shrink-0" data-id="element-20">
                  <CheckCircle2 className="text-green-400" size={20} data-id="element-21" />
                </div>
                <span className="text-lg text-white/80" data-id="element-22">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Not For Who */}
        <motion.div className="glass-card p-8 md:p-10 rounded-3xl border-red-500/30 relative overflow-hidden" initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-23">
          <div className="absolute top-0 left-0 w-full h-2 bg-red-500/50" data-id="element-24" />
          <div className="absolute -right-20 -top-20 w-64 h-64 bg-red-500/10 rounded-full blur-3xl -z-10" data-id="element-25" />

          <h2 className="text-3xl font-bold mb-8 text-white flex items-center gap-3" data-id="element-26">
            <XCircle className="text-red-400" size={36} data-id="element-27" />
            Esto NO Es Para Ti Si...
          </h2>

          <ul className="space-y-6" data-id="element-28">
            {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-29">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-30">
                  <XCircle className="text-red-400" size={20} data-id="element-31" />
                </div>
                <span className="text-lg text-white/80" data-id="element-32">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </Section>;
}